//import PubSub from "core/pubsub/pubsub-js.js";
import pubsub from "core/global/global";
import CustomEvent from "core/customEvent/index";

export default function FloatMessageBox({
  title,
  message,
  buttonType,
  hasCloseButton,
  hasTodayOffButton,
  handleYesClick
}) {
  const payload = {
    title: title,
    message: message,
    buttonType: buttonType,
    hasCloseButton: hasCloseButton,
    handleYesClick: handleYesClick,
    hasTodayOffButton: hasTodayOffButton,
    handleNoClick: null
  };

  pubsub.publish(CustomEvent.Messages.OPEN_MESSAGE_BOX, payload);
}
